/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseAction/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonClose from 'DesignSystem/TysiaButtonClose/index'



/** @type {import('Simple/types.js').View} */
export default function CloseAction({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Header/CloseAction",
  onClose
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onClose
  
})
  return (<React.Fragment
>
<TysiaButtonClose
  viewPath={`${viewPath}/TysiaButtonClose`}
 type="ghost"
 onClick={onClick}
 onClose={onClose}
/>
{children}
</React.Fragment>)
}